import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-service',
  template: `
  <div class="form-group p-3 bg-light rounded-3">
      <div class="">
          <div class="col-md-9">
              <label class="form-control-label">Concepto</label>
              <input type="text" class="form-control" [value]="service.name" />
          </div>
          <div class="col-md-3">
              <label class="form-control-label">Monto</label>
              <input type="text" class="form-control" [value]="service.price" />
          </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ItemServiceComponent implements OnInit {

  @Input() service: any = {};

  constructor() { }

  ngOnInit(): void {
    
  }

}
